import { Component, OnInit } from '@angular/core';
import { NavParams, NavController, AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-generic-choice',
  templateUrl: './generic-choice.page.html',
  styleUrls: ['./generic-choice.page.scss'],
})
export class GenericChoicePage implements OnInit {
  protected otherOptionInput : string = "";

  protected saveChangesButton : boolean = false;

  protected nextButtonHidden : boolean = true;

  protected newOption : any;

  protected userData : any; //var for logged 'user' data

  protected pageParameters : any;

  protected greyText : boolean = false;

  constructor(public alertCtrl: AlertController, public navParams: NavParams, public translate: TranslateService, public modalCtrl: ModalController) {
    this.userData = this.navParams.get('theSoul'); //getting 'user' data
    this.pageParameters = this.navParams.get('pageParameters');

    console.log(this.pageParameters.options);
    for(let option of this.pageParameters.options){
      console.log(option.label);
    }
    this.newOption = this.userData[this.pageParameters.fieldName];
    console.log(this.newOption);
    this.otherOptionInput = this.userData.genderdescription

    if(this.pageParameters.greySection){
      this.greyText = this.pageParameters.greySection;
    }
    
  }

  ngOnInit() {
  }

  hasLongLabels(): boolean {
    return this.pageParameters.options.some((opt: { label: string | any[]; }) => opt.label.length > 25);
  }


  //get choices from modal 
  setNewOption(value : string){

    this.showSaveButton();
    this.setOtherGenderStatus();

    //alert("tipo de new option: "+typeof this.newOption);
    //alert(value);
    //alert(this.newOption);

    if(value != this.newOption){
      this.setOption(value);
    } else if(this.pageParameters.unselectable && value == this.newOption) {
      //alert("igual");
      this.setOption("");
    }

  }

  //==========| Gender |==============
  //sets otherGenderInput visibility
  setOtherGenderStatus(){
    return (this.newOption == 'other' ? false : true);
  }

  // //sets what's been written in 'otherGenderInput' as gender description without changing selected option
  inputOtherOptionLostFocus(){
    // Only save the description, don't change the selected gender option
    this.userData.genderdescription = this.otherOptionInput;
    //alert("other gender escrito: "+ this.otherOptionInput);
  }
  // //=========| // |===============

  //closes modal without saving
  exitButton(){
    this.modalCtrl.dismiss('exitModal');
  }

  //switches 'exitButton' to 'saveButton'
  showSaveButton(){
    this.saveChangesButton = true;
  }

  //saves changes made by user
  saveButton(){
    this.saveOption();
    this.modalCtrl.dismiss('exitModal');
  }

  //checks if 'newOption' was already in array
  hasOption(newOption : string){
    return this.newOption.has(newOption);
  }

  //adds option into 'newGenericOptions'
  addOption(chosenOption : string){
    this.newOption.add(chosenOption);
  }

  //removes option from 'newOption'
  removeOption(chosenOption : string){
    this.newOption.delete(chosenOption);
  }

  //sets 'nextButton's visibility
  hideNextButton(choice : boolean){
    this.nextButtonHidden = choice;
  }

  async showModalAlert(message:any) {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        // {
        //   text: this.translate.instant('cancel'),
        //   handler: () => {
        //     console.log('cancel clicked');
        //     return;

        //   }
        // },
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }

  //"goes back" 1 modal and doesn't saves info
  backButton(){
    if(this.pageParameters.firstSetup && this.newOption == null){
      this.showModalAlert(this.translate.instant("forgotToChoose"));
    } else {
      this.saveOption();
      this.modalCtrl.dismiss('backModal');
    }
  }

  //saves info and closes modal
  nextButton(){
    if(this.pageParameters.firstSetup && this.newOption == null){
      this.showModalAlert(this.translate.instant("forgotToChoose"));
    } else {
      this.saveOption();
      this.modalCtrl.dismiss('nextModal');
    }    
  }

  saveOption(){
    if(this.pageParameters.fieldName == 'language') {
      this.userData.setLanguageManually = true;
      this.translate.use(this.newOption);
    }
    //alert(this.newOption);
    if(this.newOption == undefined){
      delete this.userData[this.pageParameters.fieldName];
    }else{
      this.userData[this.pageParameters.fieldName] = this.newOption;
    }

    // Save gender description if it exists
    if(this.pageParameters.fieldName == 'gender2' && this.otherOptionInput){
      this.userData.genderdescription = this.otherOptionInput;
    }

    //alert("colocado: "+ this.newOption+ "\n settado: "+ this.userData[this.pageParameters.fieldName]);
  }

  //sets 'choice'
  setOption(newOption : string | any){
    let genderOptions = new Set(['male', 'female', 'other'])  //change to use pageParameters.options instead

    //checks what's been written on input and sets as 'other' on DB
    if(this.pageParameters.fieldName == 'gender2' && !genderOptions.has(newOption)){
      this.setOption('other');
      this.userData.genderdescription = newOption;

      //alert("gender description: " + this.userData.genderdescription);

    }
     else {
      this.newOption = newOption;
    }

  }
}